import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { ListingDisclaimer } from '~/apps/consumer/pages/Storefront/ListingDisclaimer';
import { EditComps } from '../../../Comparables/EditComps/EditComps';
import { useBuyerOfferAnalysisContext } from '../../Context/BuyerOfferAnalysisContext';

export const EditCompsModal = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const geocoderInputRef = useRef<HTMLInputElement>(null);

  const {
    listing,
    comparableSet,
    comps,
    setComps,
    isEditCompsModalOpen,
    onEditCompsModalClose,
    setIsCompsUpdated,
    buyerOfferAnalysisLoading,
    initialSelectedComp,
    setInitialSelectedComp,
  } = useBuyerOfferAnalysisContext();

  const mainListing = listing;

  const onAdd = () => {
    geocoderInputRef.current?.focus();
  };

  if (!mainListing) {
    if (!buyerOfferAnalysisLoading) {
      onEditCompsModalClose();
    }

    return null;
  }

  const onAdjustmentsUpdate = () => {
    setIsCompsUpdated(true);
  };

  const onClose = () => {
    setInitialSelectedComp(undefined);
    onEditCompsModalClose();
  };

  return (
    <Modal
      isOpen={isEditCompsModalOpen}
      scrollBehavior="inside"
      size="full"
      trapFocus={false}
      onClose={onClose}
    >
      <ModalContent>
        <ModalHeader>Edit Comps</ModalHeader>
        <ModalCloseButton />
        <ModalBody
          ref={containerRef}
          px={{ base: 0, md: 10 }}
          py={{ base: 0, md: 4 }}
        >
          <Flex direction="column" gap={4}>
            <EditComps
              comparableSet={comparableSet}
              comps={comps}
              containerRef={containerRef}
              geocoderInputRef={geocoderInputRef}
              initialSelectedComp={initialSelectedComp}
              listing={mainListing}
              setComps={setComps}
              setInitialSelectedComp={setInitialSelectedComp}
              onAdd={onAdd}
              onAdjustmentsUpdate={onAdjustmentsUpdate}
            />
            <ListingDisclaimer mls={listing?.mlsListing?.mls} />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
